import { Gift, ShoppingBag, Sparkles } from "lucide-react";
import Button from "../../components/ui/button";
import { LeadFormDialog } from "./LeadFormDialog";
import { useTranslation } from "react-i18next";

const offers = [
  {
    icon: Gift,
    title: "Free Setup",
    description: "No hidden fees, no credit card needed",
  },
  {
    icon: ShoppingBag,
    title: "Surprise Gifts",
    description: "Exclusive rewards for early sign-ups",
  },
  {
    icon: Sparkles,
    title: "Premium Features Unlocked",
    description: "Limited time offer for new retailers",
  },
];

export const OffersSection = () => {
  const { t } = useTranslation();
  return (
    <section className="py-8 md:py-12 bg-gradient-to-b from-highlight/10 to-background">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-foreground mb-4">
          {t("Exclusive Free Deals — Only for")}{" "}
          <span className="text-primary">{t("New Sign-Ups")}</span>
        </h2>
        <p className="text-center text-muted-foreground mb-8 md:mb-12 text-base md:text-lg">
          {t("Limited time offers you don't want to miss")}
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-12">
          {offers.map((offer, index) => (
            <div
              key={index}
              className="p-4 md:p-8 rounded-2xl shadow-[var(--shadow-medium)] text-center 
                 hover:border-highlight hover:scale-105 transition-all duration-300 
                 bg-[#ecf6ff]"
            >
              <div className="flex justify-center mb-3 md:mb-4">
                <div className="p-3 md:p-4 rounded-full flex items-center justify-center">
                  <offer.icon className="w-6 h-6 md:w-8 md:h-8 text-highlight" />
                </div>
              </div>
              <h3 className="text-sm md:text-xl font-semibold md:font-bold text-foreground mb-2 md:mb-3">
                {t(offer.title)}
              </h3>
              <p className="text-[11px] md:text-base text-muted-foreground leading-snug md:leading-normal">
                {t(offer.description)}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center bg-card p-4 md:p-8 rounded-xl md:rounded-2xl shadow-[var(--shadow-soft)] border border-border max-w-2xl mx-auto">
          <p className="text-base sm:text-lg md:text-xl font-semibold text-foreground mb-4 md:mb-6">
            {t("Want to know what's included? Fill the form to find out!")}
          </p>
          <LeadFormDialog>
            <Button className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-6 md:px-8 py-4 md:py-6 text-base md:text-lg">
              {t("Unlock My Free Deals")}
            </Button>
          </LeadFormDialog>
        </div>
      </div>
    </section>
  );
};
